import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Sidebar';
import '../CompanyHistory.css';

const ESG = () => {
  const [activeSection, setActiveSection] = useState('environment');
  
  const sidebarItems = [
    { name: 'Environment', path: 'environment' },
    { name: 'Social', path: 'social' },
    { name: 'Governance', path: 'governance' }
  ];

  // 스크롤 스파이 기능
  useEffect(() => {
    const handleScroll = () => {
      const sections = sidebarItems.map(item => item.path);
      const scrollPosition = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Sidebar 
        category="ESG" 
        items={sidebarItems} 
        activeSection={activeSection}
        onItemClick={scrollToSection}
      />
      <div className="company-history-page">
        <div className="history-container">
          <h1 className="page-category-title">ESG</h1>
          
          {/* 환경 섹션 */}
          <section id="environment" className="section">
            <h2 className="section-title">Environment</h2>
            <div className="section-container">
              <div className="esg-grid">
                <div className="esg-item">
                  <img src="/esg/E-1.환경경영 방침(2025년).png" alt="Environmental Management Policy" className="esg-image" />
                  <h3 className="esg-title">Environmental Management Policy</h3>
                </div>
                <div className="esg-item">
                  <img src="/esg/E-2.환경전략5대정책(2025년).png" alt="5 Environmental Strategic Policies" className="esg-image" />
                  <h3 className="esg-title">5 Environmental Strategic Policies</h3>
                </div>
                <div className="esg-item">
                  <img src="/esg/E-3.온실가스배출량-환경성과지표의미.png" alt="Greenhouse Gas Emissions" className="esg-image" />
                  <h3 className="esg-title">Greenhouse Gas Emissions</h3>
                </div>
                <div className="esg-item">
                  <img src="/esg/E-4.온실가스배출량-환경관리지표의미.png" alt="Greenhouse Gas Emissions 2" className="esg-image" />
                  <h3 className="esg-title">Greenhouse Gas Emissions 2</h3>
                </div>
                <div className="esg-item">
                  <img src="/esg/E-5.친환경공사납품실적.png" alt="Eco-Friendly Construction Delivery Records" className="esg-image" />
                  <h3 className="esg-title">Eco-Friendly Construction Delivery Records</h3>
                </div>
              </div>
            </div>
          </section>

          {/* 사회 섹션 */}
          <section id="social" className="section">
            <h2 className="section-title">Social</h2>
            <div className="section-container">
              <div className="esg-grid">
                <div className="esg-item">
                  <img src="/esg/S-0.근로자 인권보호.png" alt="Worker Rights Protection" className="esg-image" />
                  <h3 className="esg-title">Worker Rights Protection</h3>
                </div>
                <div className="esg-item">
                  <img src="/esg/S-1.안전보건 방침(2025년).png" alt="Safety and Health Policy" className="esg-image" />
                  <h3 className="esg-title">Safety and Health Policy</h3>
                </div>
              </div>
            </div>
          </section>

          {/* 지배구조 섹션 */}
          <section id="governance" className="section">
            <h2 className="section-title">Governance</h2>
            <div className="section-container">
              <div className="esg-grid">
                <div className="esg-item">
                  <img src="/esg/G-1.ESG 개요.png" alt="ESG Overview" className="esg-image" />
                  <h3 className="esg-title">ESG Overview</h3>
                </div>
                <div className="esg-item">
                  <img src="/esg/G-2.경영안정성.png" alt="Management Stability" className="esg-image" />
                  <h3 className="esg-title">Management Stability</h3>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default ESG;
